import { z } from 'zod';
import { EventSourceSchema, UlidSchema } from './common';

/** Metric event as sent on the EVENTS queue and stored in D1 `events`. */
export const EventInputSchema = z.object({
  type: z.string().regex(/^[a-z_]+(\.[a-z_]+)+$/, 'dotted lowercase, e.g. job.apply'),
  actor: z.string().max(128).nullish(),
  entityKind: z.string().max(32).nullish(),
  entityId: z.string().max(128).nullish(),
  orgId: z.string().max(128).nullish(),
  source: EventSourceSchema.default('human'),
  referrer: z.string().max(2048).nullish(),
  meta: z.record(z.string(), z.unknown()).default({}),
});
export const EventMessageSchema = EventInputSchema.extend({
  id: UlidSchema,
  ts: z.number().int().nonnegative(),
});
export type EventInput = z.input<typeof EventInputSchema>;
export type EventMessage = z.output<typeof EventMessageSchema>;
